const API_URL = 'https://loomelectronicparts.com/api';

export const api = {
  baseURL: API_URL,
  
  login: async (email, password) => {
    const response = await fetch(`${API_URL}/auth.php?action=login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    return response.json();
  },

  register: async (name, email, password) => {
    const response = await fetch(`${API_URL}/auth.php?action=register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password })
    });
    return response.json();
  },

  getProducts: async () => {
    const response = await fetch(`${API_URL}/products.php`);
    return response.json();
  },

  createProduct: async (data) => {
    const response = await fetch(`${API_URL}/products.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  getCategories: async () => {
    const response = await fetch(`${API_URL}/categories.php`);
    return response.json();
  },

  createCategory: async (name) => {
    const response = await fetch(`${API_URL}/categories.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name })
    });
    return response.json();
  },

  createOrder: async (userId, items, total) => {
    const response = await fetch(`${API_URL}/orders.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, items, total })
    });
    return response.json();
  },

  createGuestOrder: async (orderData) => {
    const response = await fetch(`${API_URL}/orders.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData)
    });
    return response.json();
  },

  getOrders: async (userId) => {
    const response = await fetch(`${API_URL}/orders.php?user_id=${userId}`);
    return response.json();
  },

  getAllOrders: async () => {
    try {
      const response = await fetch(`${API_URL}/orders.php`);
      const text = await response.text();
      if (!text) return [];
      return JSON.parse(text);
    } catch (error) {
      console.error('Error fetching orders:', error);
      return [];
    }
  },

  deleteOrder: async (orderId) => {
    const response = await fetch(`${API_URL}/orders.php?id=${orderId}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  getOrderDetails: async (orderId) => {
    const response = await fetch(`${API_URL}/orders.php?order_id=${orderId}`);
    return response.json();
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await fetch(`${API_URL}/upload.php`, {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  updateProduct: async (id, data) => {
    const response = await fetch(`${API_URL}/products.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  deleteProduct: async (id) => {
    const response = await fetch(`${API_URL}/products.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  updateCategory: async (id, name) => {
    const response = await fetch(`${API_URL}/categories.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name })
    });
    return response.json();
  },

  deleteCategory: async (id) => {
    const response = await fetch(`${API_URL}/categories.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  updateOrderStatus: async (orderId, status) => {
    const response = await fetch(`${API_URL}/orders.php?id=${orderId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status })
    });
    return response.json();
  },

  updateUser: async (id, name, email, password, role) => {
    const data = { id, name, email, role };
    if (password) data.password = password;
    const response = await fetch(`${API_URL}/users.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  getProvinces: async () => {
    const response = await fetch(`${API_URL}/provinces.php`);
    return response.json();
  },

  createProvince: async (name) => {
    const response = await fetch(`${API_URL}/provinces.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name })
    });
    return response.json();
  },

  updateProvince: async (id, name, newId = null) => {
    const body = { name };
    if (newId) body.new_id = newId;
    const response = await fetch(`${API_URL}/provinces.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    return response.json();
  },

  deleteProvince: async (id) => {
    const response = await fetch(`${API_URL}/provinces.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  getCities: async (province_id) => {
    const url = province_id ? `${API_URL}/cities.php?province_id=${province_id}` : `${API_URL}/cities.php`;
    const response = await fetch(url);
    return response.json();
  },

  createCity: async (province_id, name) => {
    const response = await fetch(`${API_URL}/cities.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ province_id, name })
    });
    return response.json();
  },

  updateCity: async (id, name) => {
    const response = await fetch(`${API_URL}/cities.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name })
    });
    return response.json();
  },

  deleteCity: async (id) => {
    const response = await fetch(`${API_URL}/cities.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  getDistricts: async (city_id) => {
    const url = city_id ? `${API_URL}/districts.php?city_id=${city_id}` : `${API_URL}/districts.php`;
    const response = await fetch(url);
    return response.json();
  },

  createDistrict: async (city_id, name) => {
    const response = await fetch(`${API_URL}/districts.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ city_id, name })
    });
    return response.json();
  },

  updateDistrict: async (id, name) => {
    const response = await fetch(`${API_URL}/districts.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name })
    });
    return response.json();
  },

  getUsers: async () => {
    const response = await fetch(`${API_URL}/users.php`);
    return response.json();
  },

  deleteDistrict: async (id) => {
    const response = await fetch(`${API_URL}/districts.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // Product stats functions
  trackCartAddition: async (productId, quantity = 1) => {
    const response = await fetch(`${API_URL}/product_stats.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        action: 'add_to_cart', 
        product_id: productId, 
        quantity 
      })
    });
    return response.json();
  },

  getProductStats: async () => {
    const response = await fetch(`${API_URL}/product_stats.php?action=stats`);
    return response.json();
  },

  // Status Automation functions
  getStatusAutomation: async () => {
    const response = await fetch(`${API_URL}/status_automation.php`);
    return response.json();
  },

  updateStatusAutomation: async (id, hours_delay, is_enabled) => {
    const response = await fetch(`${API_URL}/status_automation.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        action: 'update_rule',
        id,
        hours_delay,
        is_enabled
      })
    });
    return response.json();
  },

  toggleStatusAutomation: async (id, is_enabled) => {
    const response = await fetch(`${API_URL}/status_automation.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, is_enabled })
    });
    return response.json();
  },

  processStatusAutomation: async () => {
    const response = await fetch(`${API_URL}/status_automation.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'process_automation' })
    });
    return response.json();
  },

  // Custom Fields functions
  getCustomFields: async () => {
    const response = await fetch(`${API_URL}/custom_fields.php`);
    return response.json();
  },

  createCustomField: async (name, label, type) => {
    const response = await fetch(`${API_URL}/custom_fields.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, label, type })
    });
    return response.json();
  },

  updateCustomField: async (id, label, type, is_visible) => {
    const response = await fetch(`${API_URL}/custom_fields.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, label, type, is_visible })
    });
    return response.json();
  },

  deleteCustomField: async (id) => {
    const response = await fetch(`${API_URL}/custom_fields.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // Slider functions
  getSlides: async () => {
    const response = await fetch(`${API_URL}/slider.php`);
    return response.json();
  },

  createSlide: async (formData) => {
    const response = await fetch(`${API_URL}/slider.php`, {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  updateSlide: async (id, data) => {
    const response = await fetch(`${API_URL}/slider.php?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },

  deleteSlide: async (id) => {
    const response = await fetch(`${API_URL}/slider.php?id=${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};
